import { mapActions } from 'vuex'
import Vue from 'vue'
export const steps_missions = [
  {
    target: '[gt_ParamOrbitTransfert2-v-step="1"]',
    content:
      'In this second part of the tutorial we will explore further the parametric orbital transfer module.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="2"]',
    content:
      'Firstly, select the mission created in the first part of the tutorial and click <strong>Edit</srtong>.',
    params: {
      enableScrolling: false
    }
  }
]
export const steps_analytical_mission2 = [
  {
    target: '[gt_ParamOrbitTransfert2-v-step="3"]',
    content:
      'You should now see the mission you created in the first part of this tutorial.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="4"]',
    content:
      'In the spacecraft field, click <strong>Edit</strong> on the currently selected spacecraft.'
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="8"]',
    content:
      'You can leave all other parameters to their previous value and click <strong>Save</strong>.'
  }
]
export const steps_analytical_spacecraft2 = [
  {
    target: '[gt_ParamOrbitTransfert2-v-step="5"]',
    content:
      'In the<strong>Orbital average power for propulsion</strong>, tick the box <strong>Range</strong>.',
    params: {
      placement: 'top',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="6"]',
    content:
      'Select range type <strong>Number</strong>, number of points <strong>10</strong>, min <strong>40</strong> and max <strong>200</strong>.',
    params: {
      placement: 'top',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="7"]',
    content: 'Click <strong>Save</strong>.'
  }
]
export const steps_analytical_dashboard2 = [
  {
    target: '[gt_ParamOrbitTransfert2-v-step="9"]',
    content: 'Click on <strong>Start computation</strong> to see the results.'
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="10"]',
    content:
      'We will now create some graphs to have a better understanding of the progression of the mission.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="11"]',
    content: 'Click on <strong>add plot</strong>.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="15"]',
    content: 'Click on <strong>add plot</strong> again (1).',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="19"]',
    content: 'Now click on <strong>add plot</strong> again (2).',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="25"]',
    content:
      'You see now that you can plot data from your mission in various different ways.'
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="26"]',
    content: 'You can also edit or delete your graphs.'
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="27"]',
    content:
      'And you can save the layout of the dashboard by clicking on the <strong>save</strong> icon.'
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="28"]',
    content: 'Congratulations, you just finished this tutorial !',
    params: {
      enableScrolling: false
    }
  }
]
export const steps_analytical_plot_configuration = [
  {
    target: '[gt_ParamOrbitTransfert2-v-step="12"]',
    content: 'For the y field, select <strong>ΔV</strong>.',
    params: {
      placement: 'left'
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="13"]',
    content:
      'For the x field, select <strong>Propulsion system mean duty cycle</strong>.',
    params: {
      placement: 'left'
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="14"]',
    content:
      'You can add a title to your graph and click <strong>draw</strong>.'
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="16"]',
    content: 'For the y field, select <strong>mission duration</strong>.',
    params: {
      placement: 'left'
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="17"]',
    content:
      'For the x field, select <strong>Propulsion system mean duty cycle</strong> again.',
    params: {
      placement: 'left'
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="18"]',
    content:
      'You can add a title to your graph and click <strong>draw</strong>.'
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="20"]',
    content: 'This time, change the type to <strong>multi axis</strong>.',
    params: {
      placement: 'left'
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="21"]',
    content: 'For the y1 field, select <strong>ΔV</strong>.',
    params: {
      placement: 'left'
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="22"]',
    content:
      'Click on the plus icon. Then, for the y2 field, select <strong>mission duration</strong>.',
    params: {
      placement: 'left'
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="23"]',
    content:
      'For the x axis select <strong>propulsion system mean duty cycle</strong>.',
    params: {
      placement: 'left'
    }
  },
  {
    target: '[gt_ParamOrbitTransfert2-v-step="24"]',
    content: 'Now click on <strong>draw</strong> again.',
    params: {
      placement: 'left'
    }
  }
]

export default {
  ...mapActions(['start_gt_OrbitTransferParam2']),
  stopAllTours(component) {
    for (const key of Object.keys(component.gt_OrbitTransferParam2)) {
      component.start_gt_OrbitTransferParam2({ param: key, val: false })
    }
    for (const tour in component.$tours) {
      component.$tours[tour].stop()
    }
  },
  onNextStepPlot(component, currentStep) {
    component.currentStep = currentStep
    if (currentStep === 0) {
      if (component.configuration.y.value == null) {
        this.repeatStep(component, 0)
      }
    } else if (currentStep === 1) {
      if (component.configuration.x.value == null) {
        this.repeatStep(component, 1)
      }
    } else if (currentStep === 2) {
      component.updatePlotData()
      component.gt_OrbitTransferParam2.firstPlotDone = true
      component.$tours['paramOrbitalTransfer2TourAnaPlot'].stop()
    } else if (currentStep === 3) {
      if (component.configuration.y.value == null) {
        this.repeatStep(component, 3)
      }
    } else if (currentStep === 4) {
      if (component.configuration.x.value == null) {
        this.repeatStep(component, 4)
      }
    } else if (currentStep === 5) {
      component.updatePlotData()
      component.gt_OrbitTransferParam2.secondPlotDone = true
      component.$tours['paramOrbitalTransfer2TourAnaPlot'].stop()
    } else if (currentStep === 6) {
      if (component.configuration.type !== 'Multi axis') {
        this.repeatStep(component, 6)
      }
    } else if (currentStep === 7) {
      if (component.configuration.multiAxis[0]?.label == null) {
        this.repeatStep(component, 7)
      }
    } else if (currentStep === 8) {
      if (component.configuration.multiAxis[1]?.label == null) {
        this.repeatStep(component, 8)
      }
    } else if (currentStep === 9) {
      if (component.configuration.x.value == null) {
        this.repeatStep(component, 9)
      }
    }
  },
  onFinishPlot(component) {
    component.updatePlotData()
    component.gt_OrbitTransferParam2.thirdPlotDone = true
    component.$tours['paramOrbitalTransfer2TourAnaPlot'].stop()
  },
  handleVisibilityPlotWindow(component) {
    component.$tours['paramOrbitalTransfer2TourAnaPlot'].stop()
    if (
      !component.gt_OrbitTransferParam2.firstPlotDone &&
      component.currentStep != -1
    ) {
      component.makeTemporary = true
      component.gt_OrbitTransferParam2.firstPlotDone = true
    } else if (
      !component.gt_OrbitTransferParam2.secondPlotDone &&
      component.currentStep > 3
    ) {
      component.makeTemporary = true
      component.gt_OrbitTransferParam2.secondPlotDone = true
    } else if (
      !component.gt_OrbitTransferParam2.thirdPlotDone &&
      component.currentStep > 5
    ) {
      component.makeTemporary = true
      component.gt_OrbitTransferParam2.thirdPlotDone = true
    }
  },
  handleRedirectOnTutorialParamOrbitalTransfer2(component, mission, eventName) {
    if (
      mission.typeName === 'ParametricStudyRequest' &&
      mission.type === 'Orbital Transfer'
    ) {
      component.editMissionIsClicked = true
      component.redirectToMissionSetting(mission.typeName)
      Vue.nextTick(() => {
        component.$root.$emit(eventName, mission)
      })
    } else {
      component.$tours['paramOrbitalTransfer2TourMissions'].start(1)
    }
  },
  onNextAnaDashboard(component, currentStep) {
    if (component.displayComputationWidget) {
      component.$tours['paramOrbitalTransfer2TourResult'].start()
    } else if (currentStep === 2 || currentStep === 3 || currentStep === 4) {
      if (!component.addPlotIsClicked) {
        component.addPlotConfiguration()
      } else {
        component.addPlotIsClicked = false
      }
      if (!component.gt_OrbitTransferParam2.firstPlotDone) {
        component.$tours['paramOrbitalTransfer2TourAnaPlot'].start(0)
      } else if (!component.gt_OrbitTransferParam2.secondPlotDone) {
        component.$tours['paramOrbitalTransfer2TourAnaPlot'].start(3)
      } else {
        component.$tours['paramOrbitalTransfer2TourAnaPlot'].start(6)
      }
    }
  },
  onNextAnaMission(component, currentStep) {
    if (currentStep === 1) {
      if (
        component.inputs.spacecraft.parametricValues['orbitalAveragePower'] ==
        null
      ) {
        component.$tours['paramOrbitalTransfer2TourAnaMission'].start(1)
      } else {
        component.gt_OrbitTransferParam2.firstMissionTourDone = true
      }
    }
  },
  onNextAnaSC(component, currentStep) {
    if (currentStep === 0) {
      component.inputs.orbitalAveragePower = 'NaN'
      component.inputs.parametricValues.orbitalAveragePower.active = true
    }
  },
  onSkipAnaMission(component) {
    if (
      component.inputs.spacecraft.parametricValues['orbitalAveragePower'] ==
        null ||
      !component.inputsValid
    ) {
      component.$tours['paramOrbitalTransfer2TourAnaMission'].start(1)
    } else {
      component.submitForm()
    }
  },
  onSkipAnaSC(component) {
    component.inputs.orbitalAveragePower = 'NaN'
    component.inputs.parametricValues.orbitalAveragePower.active = true
    component.submitForm()
  },
  beginParamOrbitalTranfer2Tour(component) {
    if (!component.gt_OrbitTransferParam2.firstMissionTourDone) {
      component.$tours['paramOrbitalTransfer2TourAnaMission'].start()
      component.gt_OrbitTransferParam2.firstMissionTourDone = true
    } else if (component.gt_OrbitTransferParam2.firstMissionTourDone) {
      component.$tours['paramOrbitalTransfer2TourAnaMission'].start(2)
    }
  },
  handleClickOnAddPlotGuidedTutorial(component) {
    component.addPlotIsClicked = !component.addPlotConfiguration
    if (component.gt_OrbitTransferParam2.isActive) {
      if (!component.gt_OrbitTransferParam2.firstPlotDone) {
        component.$tours['paramOrbitalTransfer2TourResult'].stop()
        component.$tours['paramOrbitalTransfer2TourAnaPlot'].start(0)
      } else if (!component.gt_OrbitTransferParam2.secondPlotDone) {
        component.$tours['paramOrbitalTransfer2TourResult'].stop()
        component.$tours['paramOrbitalTransfer2TourAnaPlot'].start(3)
      } else {
        component.$tours['paramOrbitalTransfer2TourResult'].stop()
        component.$tours['paramOrbitalTransfer2TourAnaPlot'].start(6)
      }
    }
  },
  repeatStep(component, step) {
    component.$tours['paramOrbitalTransfer2TourAnaPlot'].start(step)
    component.currentStep--
  }
}
